import styled from 'styled-components';

export const ContainerDesktop = styled.div`
  display: none;
  @media (min-width: 600px) {
    display: block;
  }
`;

export const ContainerMobile = styled.div`
  display: block;
  @media (min-width: 600px) {
    display: none;
  }
`;
